import React, { useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import signupImg from "../assets/img/login.jpeg";

function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/auth/signup", { email, password });
      navigate("/login");
    } catch (err) {
      alert(err.response?.data?.message || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet><title>LCWE | Signup</title></Helmet>

      <section className="p-3 p-md-4 p-xl-5">
        <div className="container">
          <div className="card border-light-subtle shadow-sm">
            <div className="row g-0">
              <div className="col-md-6">
                <img src={signupImg} className="img-fluid rounded-start w-100 h-100 object-fit-cover" alt="Signup" />
              </div>
              <div className="col-12 col-md-6">
                <div className="mb-5"> 
                  <h3>Create Account</h3> 
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row gy-3 gy-md-4 overflow-hidden">
                    <div className="col-12">
                    <label htmlFor="email" className="form-label"> 
                      Email <span className="text-danger">*</span> 
                    </label>
                    <input type="email" className="form-control mb-3"
                    placeholder="Email" value={email}
                    onChange={e => setEmail(e.target.value)} required />
                  </div>

                  <div className="col-12">
                    <label htmlFor="password" className="form-label">
                      Password <span className="text-danger">*</span>
                    </label>
                    <input type="password" className="form-control mb-3"
                    placeholder="Password" value={password} id="password"
                    onChange={e => setPassword(e.target.value)} required />
                  </div>

                  <div className="col-12">
                    <div className="d-grid">
                      <button className="btn btn-primary w-100" disabled={loading}>
                        {loading ? "Creating..." : "Sign Up"}
                      </button>
                    </div>
                  </div>
                  
                  <div className="col-12 text-center mt-3"> Already have an account?{" "} <a href="/login">Sign in here</a> </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Signup;
